module.exports = __webpack_public_path__ + "static/media/close-circle-PMC.69016720.svg";